module.exports = __webpack_public_path__ + "static/media/marking-work.4e76a8bf.jpg";